"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlResolver = void 0;
const resolver_1 = require("./resolver");
class HtmlResolver extends resolver_1.Resolver {
    constructor(defaultValues) {
        super(defaultValues);
    }
    static replaceCriteria(message, key, value) {
        const regExpReplacer = new RegExp('\\<' + key + '>(.+?)</' + key + '>', 'g');
        try {
            if (HtmlResolver.isHTMLValueType(value)) {
                return message.replace(regExpReplacer, value);
            }
            if (HtmlResolver.isHTMLFnValueType('test', value)) {
                return message.replace(regExpReplacer, value('$1'));
            }
            return message;
        }
        catch (_a) {
            return message;
        }
    }
    resolveCriteria(message, key, value) {
        return HtmlResolver.replaceCriteria(message, key, value);
    }
}
exports.HtmlResolver = HtmlResolver;
HtmlResolver.isHTMLValueType = (value) => {
    return typeof value === 'string';
};
HtmlResolver.isHTMLFnValueType = (key, value) => {
    try {
        return HtmlResolver.isHTMLValueType(value(key));
    }
    catch (_a) {
        return false;
    }
};
//# sourceMappingURL=htmlResolver.js.map